<template>
	<div class='mzl'>


		<div class='grid select-value-block'>

			<div>
				<span class='select-title'>Санитарно-оздоровительное мероприятие</span>
				<span>Рубка аварийных деревьев</span>

			</div>

		</div>

		<div class='grid select-value-block'>
			
			<div>
				<span class='select-title'>Мероприятия для смежных деревьев</span>
				<span>Своевременное проведение мероприятия, вывозка неокоренной древесины</span>
			</div>

			<div :class='{ "not-match": !isMatch(values["mzl_period_to"]) }'>
				<span class='select-title'>Крайние сроки</span>
				<input type='date' class='custom-input' v-model='values["mzl_period_to"].value'>
			</div>

		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'InspectionMzl',
		data() {
			return {
				values: {

					mzl_period_to: {
						field: 'mzl_period_to',
						inputType: 'input',
						value: null
					},

				},

			};
		},
		computed: {
			isManual() {
				return this.rightMzl ? this.rightMzl.is_manual === 't' ? true : false : false;
			},

			notManualValue() {
				return this.rightMzl ? this.rightMzl.name + ' (автоматически)' : null;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			...mapState('selectedLpo', {
				lpo: state => state['lpo'],
				rightMzl: state => state['rightMzl'],
				neighborMzl: state => state['neighborMzl'],
				agitMzlList: state => state['agitMzlList'],
				profMzlList: state => state['profMzlList'],
				rightMzlIsLoading: state => state['rightMzlIsLoading']
			}),

			...mapState({
				info_critical_density: state => state.catalogs['info_critical_density'],
				info_mzl_agit: state => state.catalogs['info_mzl_agit'],
				info_mzl_prof: state => state.catalogs['info_mzl_prof'],
				info_mzl_neighbor: state => state.catalogs['info_mzl_neighbor']
			})
		},

		methods: {
			save() {

				if (this.notMatchingValues.length) {

					// console.log('lalal');
					const valueList = [];

					for (const value_name of this.notMatchingValues) {
						const inputTypeIsSelect = this.values[value_name].inputType === 'select';

						const temp = {
							field: this.values[value_name].field,
							value: inputTypeIsSelect ? this.values[value_name].value.id : this.values[value_name].value
						};
						valueList.push(temp);
					}

					this.saveLpoValue(valueList).then(res => {
						return this.updateLpo();
					});
				}

			},
			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},


			isMatch(value) {

				if (value.inputType === 'input') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			this.resetValues();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	.agit-prof-block {
		margin-top: 10px;
	}

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}
</style>